import React from 'react';



const Footer = () => {
    return (
        <div className="footer" >
            <div className="footer-container">
                <span className="footer-container__rights">Copyright © 2021 Svbooks. All rights reserved.</span>
                <a href="https://www.linkedin.com/in/yaroslav-melnyk1" rel="noopener noreferrer" target="_blank" className="footer-container__maritodd">developed by maritodd</a>
            </div>
        </div>
    );
}

export default Footer;
